import type { ActionStatus } from '../../hooks/staged-action-status'
import type { StagedAction } from '../../hooks/use-staged-actions'
import type { SidepanelChat } from '@renderer/overlay/hooks/running-chat-selection'

export type ForYouFilterType = 'all' | 'staged' | 'completed' | 'archived'

export type ForYouActionStatusGetter = (action: StagedAction) => ActionStatus

function isCompletedStatus(status: ActionStatus): boolean {
  return status === 'completed' || status === 'pending' || status === 'invoking'
}

export function selectForYouActions(
  allActions: Array<StagedAction>,
  getActionStatus: ForYouActionStatusGetter,
  filter: Extract<ForYouFilterType, 'completed' | 'archived'>,
): Array<StagedAction> {
  const matching = allActions.filter((action) => {
    const status = getActionStatus(action)
    return filter === 'archived' ? status === 'archived' : isCompletedStatus(status)
  })

  return [...matching].sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
}

export function actionBelongsToChat(action: StagedAction, chats: Array<SidepanelChat>): boolean {
  if (chats.some((chat) => chat.stagedActionIds.includes(action.id))) {
    return true
  }
  const conversationId = action.originConversationId ?? action.conversationId
  return conversationId != null && chats.some((chat) => chat.id === conversationId)
}

export function forYouEmptyMessage(filter: ForYouFilterType): string {
  if (filter === 'archived') {
    return 'No archived chats or actions'
  }
  if (filter === 'completed') {
    return 'No completed actions'
  }
  return 'Nothing for you yet'
}
